<!-- start of Table box -->
<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs placementsportlet" style="position: relative;">
    <app-loader [showLoader]=showLoad></app-loader>

    <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
         style="position: relative;">
        <div class="o-stack__cell">
            <h5>{{sectiontitle}}</h5>
	        <a href="#" class="datatable_download_icon" (click)="downloadDataInCSV($event)" target="_blank"><i class="fa fa-download" aria-hidden="true"></i></a>
        </div>
    </div>
    <div class="c-portlet__content " style="padding:9px; min-height: 415px;">
        <ngx-datatable
                class="datatable"
                [rows]="placementsData"
                [columns]="columns"
                [sortType]="'single'"
                [columnMode]="'force'"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="'auto'"
                [limit]="10"
                [reorderable]="reorderable">
        </ngx-datatable>
    </div>
</div>
<!--End of Table box -->